
import React, { useEffect, useState } from "react";
import Table from "../../../core/common/dataTable/index";
import "../employees/index.css";
import {
  searchLoansByCustomerDetails,
  updatePaymentById,
  getCustomersById,
} from "../../../apis/customers";
import Select from "react-select";
import { uploadFile } from "../../../apis/auth";
import { Link, useLocation } from "react-router-dom";
import html2pdf from "html2pdf.js";
import ImagePreviewModal from "../../components/imageView/ImagePreviewModal";
import "./print.css";
import { generateLoanPDF } from "../../../utils/generateLoanPDF";
const paymentValues = {
  paymentAmount: "",
  penaltyAmount: "",
  discount: "",
  receipt_number: "",
};

type EmployeeData = {
  key: number;
  Name: string;
  id: any;
  Image: string;
  discription: string;
  amount: number;
  Status: string;
  loan_id: string;
};
type emisResponse = {
  due_date: any;
  amount: number;
  principal: number;
  status: string;
  emi_no: any;
  loan_id: string;
};

type emisData = {
  key: number;
  due_date: any;
  id: any;
  amount: number;
  principal: number;
  status: string;
  loan_id: string;
};
type paymentsData = {
  key: string;
  paymentMode: any;
  payment_date: any;
  id: any;
  penaltyAmount: any;
  paymentAmount: any;
  receipt_number: string;
  status: string;
  utrImageUrl?: string;
  loan_id: string;
  discount: string;
};
type loansData = {
  othercharges: number;
  loan_id: string;
  key: number;
  approvalAmount: number;
  id: any;
  approvalDate: any;
  approvalfilecharge: number;
  numberOfEmis: number;
  emis: any;
  payment: any;
};

const printStyle: React.CSSProperties = {
  backgroundColor: "#f4f4f4",
  padding: "6px 10px",
  minHeight: "32px",
  fontSize: "14px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  marginTop: "5px",
  overflowWrap: "break-word",
  whiteSpace: "pre-wrap",
  width: "100%", // Let it fill the parent column
  maxWidth: "300px",
};

const PendingEmisList = () => {
  const location = useLocation();
  const aadharFromQuery = new URLSearchParams(location.search).get("aadhar")?.trim() || "";
  const [filter, setFilter] = useState<string>("");
  const [customerData, setCustomerData] = useState<any>();
  const [loanData, setLoanData] = useState<EmployeeData[]>([]);
  const [addressString, setAddress] = useState<any>();
  const [curraddressString, setCurrAddress] = useState<any>();
  const [emiData, setEmiData] = useState<emisData[]>([]);
  const [paymentData, setPaymentData] = useState<paymentsData[]>([]);
  const [emiDetail, setEmidetail] = useState();
  const [selectedOption, setSelectedOption] = useState<any>();
  const [paymentFormData, setPaymentFormData] = useState(paymentValues);
  const [products, setProducts] = useState<any>();
  const [loanNewData, setLoanNewData] = useState<any>();
  const [utrImage, setUtrImage] = useState<File | null>(null);
  const [error, setError] = useState<string>("");
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [utrImageUrl, setUtrImageUrl] = useState<string>("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const type = sessionStorage.getItem("info");
  const userType = JSON.parse(type || "{}");
  const isCustomer = String(userType?.type).toLowerCase() === "customer";
  const handleImageClick = (imgUrl: string) => {
    setSelectedImage(imgUrl);
    setShowImageModal(true);
  };

  const address = JSON.parse(addressString || "{}");
  const curraddress = JSON.parse(curraddressString || "{}");

  const fetchAllFiltersData = async (event?: any, searchValue?: string) => {
    if (event) event.preventDefault();
    const lookupValue = searchValue || filter;
    if (!lookupValue) return;
    try {
      const response = await searchLoansByCustomerDetails(lookupValue);
      if (response.status === true) {
        setCustomerData(response.data.customerDetails);
        fetchAllLoans(response.data.loanDataWithEmis);
        const permaadres = response?.data?.customerDetails?.address;
        const curreadres = response?.data?.customerDetails?.current_address;
        setAddress(permaadres);
        setCurrAddress(curreadres);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  useEffect(() => {
    if (!aadharFromQuery) return;
    setFilter(aadharFromQuery);
    fetchAllFiltersData(undefined, aadharFromQuery);
  }, [aadharFromQuery]);

  useEffect(() => {
    if (aadharFromQuery) return;
    if (!isCustomer) return;
    const loadCustomerRecords = async () => {
      let aadharNumber = userType?.aadharNumber;
      if (!aadharNumber && userType?.id) {
        const response = await getCustomersById(userType.id);
        aadharNumber = response?.data?.aadharNumber || response?.aadharNumber;
      }
      if (!aadharNumber) return;
      setFilter(aadharNumber);
      fetchAllFiltersData(undefined, aadharNumber);
    };
    loadCustomerRecords();
  }, [aadharFromQuery, isCustomer, userType?.aadharNumber, userType?.id]);

  const fetchAllLoans = async (data: any) => {
    try {
      const employeeData = data?.map((item: any, i: number) => ({
        key: `${i + 1}`,
        approvalAmount: `${item.approvalAmount}`,
        approvalDate: item.approvalDate || "--",
        approvalfilecharge: item.approvalfilecharge || "--",
        numberOfEmis: item.numberOfEmis || "--",
        emis:
          typeof item.emis === "string" ? JSON.parse(item.emis) : item || {},
        payment: item?.payments,
        id: item.id,
        loan_id: item.loan_id,
        othercharges: item?.othercharges || 0,
      }));
      setLoanData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const [balancePayment, setBalancePayment] = useState(false);
  const [paymentBalance, setPaymentBalance] = useState<any>();
  const handlePaymentBalance = async (data: { data: any }) => {
    setBalancePayment(true);
    setPaymentBalance(data?.data);
    handleChangeNewStatus(data);
  };
  const handleChangeNewStatus = async (data: { data: any }) => {
    // setBalancePayment(false);
    setEmidetail(data?.data);
    setProducts(data?.data);
    const paymentsData = data?.data?.payment ? data?.data?.payment : [];
    const parsedPaymentsData = paymentsData;

    const parsedEmis = data?.data?.emis.emis || {};
    const loanAccountNum = data?.data?.loan_id;

    const filteredEmis = parsedEmis?.filter(
      (elements: any, i: number) => elements?.status === "Pending"
    );
    const employeeData = filteredEmis?.map((item: emisResponse, i: number) => ({
      key: `${i + 1}`,
      due_date: `${item.due_date}`,
      amount: item.amount || "Not Assigned",
      principal: item.principal || "Not Assigned",
      status: item.status || "Not Assigned",
      id: item.emi_no,
      loan_id: loanAccountNum,
    }));
    setEmiData(employeeData || []);

    if (Array.isArray(parsedPaymentsData) && parsedPaymentsData.length > 0) {
      const payments: paymentsData[] = parsedPaymentsData
        .filter((item) => {
          return (
            item?.paymentDate ||
            item?.paymentAmount ||
            item?.penaltyAmount ||
            item?.receipt_number ||
            item?.utrImageUrl
          );
        })
        .map((item: any, i: number) => ({
          key: `${i + 1}`,
          payment_date: item?.paymentDate || "--",
          paymentAmount: item?.paymentAmount || 0,
          penaltyAmount: item?.penaltyAmount || 0,
          receipt_number: item?.receipt_number || "--",
          utrImageUrl: item?.utrImageUrl || "--",
          paymentMode: item?.paymentMode || "--",
          status: item?.status || "--",
          id: item?.emiId || "--",
          loan_id: loanAccountNum?.toString() || "--",
          discount: item?.discount || "0",
        }));

      setPaymentData(payments);
    } else {
      setPaymentData([]);
    }
  };

  const handlepay = async (data: { data: any }) => {
    setLoanNewData(data.data);
  };

  const handlePrint = async () => {
    await generateLoanPDF({
      customer: customerData,
      loans: loanData,
      emis: emiData,
      payments: paymentData,
    });
  };

  const emiColumn = [
    {
      title: "Sr No.",
      dataIndex: "key",
      width: 60,
      render: (_: any, record: emisData) => (
        <div className="text-dark">{record.key}</div>
      ),
    },
    {
      title: "Loan Account Number",
      dataIndex: "lona_id",
      width: 120,
      render: (_: any, record: emisData) => (
        <div className="text-dark">{record.loan_id} </div>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 100,
      render: (_: any, record: emisData) => (
        <div className="text-dark">{record.amount}</div>
      ),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      width: 100,
      render: (_: any, record: emisData) => (
        <div className="text-dark">{record.due_date}</div>
      ),
    },
    {
      title: "Principal",
      dataIndex: "principal",
      className: "hide-in-print",
      width: 100,
      render: (_: any, record: emisData) => (
        <div className="text-dark">{record.principal}</div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (_: any, record: emisData) => (
        <div className="text-dark ">{record.status}</div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      className: "hide-in-print",
      width: 100,
      render: (text: string, record: emisData) => (
        <>
          {record?.status !== "Paid" && userType.type !== "customer" && (
            <div className="d-inline-flex">
              <div className="btn btn-primary d-flex align-items-center">
                <div
                  data-bs-toggle="modal"
                  data-bs-target="#payment_modal"
                  data-bs-dismiss="modal"
                  onClick={() => handlepay({ data: record })}
                >
                  {"Pay "}
                </div>
              </div>
            </div>
          )}
        </>
      ),
    },
  ];

  const paymentColumn = [
    {
      title: "Sr No.",
      dataIndex: "key",
      width: 60,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.key}</p>
        </div>
      ),
    },
    {
      title: "Loan Account Number",
      dataIndex: "lona_id",
      width: 120,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.loan_id}</p>
        </div>
      ),
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.payment_date}</p>
        </div>
      ),
    },
    {
      title: "Payment Amount",
      dataIndex: "paymentAmount",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.paymentAmount}</p>
        </div>
      ),
    },
    {
      title: "Penalty Amount",
      dataIndex: "penaltyAmount",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.penaltyAmount}</p>
        </div>
      ),
    },
    {
      title: "Discount",
      dataIndex: "discount",
      width: 120,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.discount}</p>
        </div>
      ),
    },
    {
      title: "Payment Mode",
      dataIndex: "paymentMode",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.paymentMode}</p>
        </div>
      ),
    },
    {
      title: "UTRN Image",
      dataIndex: "amount",
      className: "hide-in-print",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <div className="ms-2">
            <img
              src={record.utrImageUrl}
              alt="UTRN Icon"
              className="me-2"
              style={{
                width: "20px",
                height: "20px",
                objectFit: "cover",
                cursor: "pointer",
              }}
              onClick={() => handleImageClick(record.utrImageUrl)}
            />
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 100,
      render: (_: any, record: paymentsData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.status}</p>
        </div>
      ),
    },
  ];

  const column = [
    {
      title: "Sr No.",
      dataIndex: "key",
      width: 60,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.key}</p>
        </div>
      ),
    },
    {
      title: "Loan Account Number",
      dataIndex: "loan_id",
      width: 120,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.loan_id}</p>
        </div>
      ),
    },
    {
      title: "Approval Amount",
      className: "hide-in-print",
      dataIndex: "approvalAmount",
      width: 100,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.approvalAmount}</p>
        </div>
      ),
    },
    {
      title: "Approval Date",
      dataIndex: "approvalDate",
      className: "hide-in-print",
      width: 100,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.approvalDate}</p>
        </div>
      ),
    },
    {
      title: "Approval File Charge",
      dataIndex: "approvalfilecharge",
      className: "hide-in-print",
      width: 120,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.approvalfilecharge}</p>
        </div>
      ),
    },
    {
      title: "Other Charge",
      dataIndex: "othercharges",
      className: "hide-in-print",
      width: 120,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.othercharges}</p>
        </div>
      ),
    },
    {
      title: "No. of Emis",
      dataIndex: "numberOfEmis",
      width: 80,
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.numberOfEmis}</p>
        </div>
      ),
    },
    {
      title: "EMI Amounut",
      dataIndex: "numberOfEmis",
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">{record.emis?.emis?.[0]?.amount}</p>
        </div>
      ),
    },
    {
      title: "Loan amount with Interest",

      dataIndex: "Loan Final Amount",
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <div>
            {record?.emis?.emis?.[0].amount * record?.emis.numberOfEmis}
          </div>
        </div>
      ),
    },
    {
      title: "Principle Amount",
      dataIndex: "numberOfEmis",
      className: "hide-in-print",
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          <p className="text-dark mb-0">
            {Number(record.approvalAmount) +
              Number(record.approvalfilecharge) +
              Number(record.othercharges) || "--"}
          </p>
        </div>
      ),
    },
    {
      title: "Payment Received",
      dataIndex: "numberOfEmis",
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          {record?.emis?.payments?.reduce(
            (total: any, payment: { paymentAmount: any }) =>
              total + (payment?.paymentAmount || 0),
            0
          ) || 0}
        </div>
      ),
    },
    {
      title: "Pending Principal",
      dataIndex: "numberOfEmis",
      render: (_: any, record: loansData) => {
        const emisList = record?.emis?.emis || [];

        const totalPendingPrincipal = emisList.reduce(
          (total: number, emi: any) => {
            if (emi?.status === "pending" || emi?.status === "Pending") {
              return total + (Number(emi?.principal) || 0);
            }
            return total;
          },
          0
        );

        return (
          <div className="d-flex align-items-center">
            ₹ {totalPendingPrincipal.toLocaleString("en-IN")}
          </div>
        );
      },
    },

    {
      title: "Balance",
      dataIndex: "numberOfEmis",
      render: (_: any, record: loansData) => (
        <div className="d-flex align-items-center">
          {record?.emis?.emis?.[0].amount * record?.emis.numberOfEmis -
            (record?.emis?.payments?.reduce(
              (total: any, payment: {
                discount: number; paymentAmount: any
              }) =>
                total + (payment?.paymentAmount || 0) + (Number(payment?.discount) || 0),
              0
            ) || 0)}
        </div>
      ),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      className: "hide-in-print",
      render: (_: any, record: loansData) => {
        const balance =
          (record?.emis?.emis?.[0]?.amount || 0) *
          (record?.emis?.numberOfEmis || 0) -
          (record?.emis?.payments?.reduce(
            (total: number, payment: { paymentAmount: number; discount: number }) =>
              total + (payment?.paymentAmount || 0) + (Number(payment?.discount) || 0),
            0
          ) || 0);
        return (
          <div className="action-icon d-inline-flex">
            <div className="me-2">
              <button
                className="btn emi_details_btn btn-primary"
                onClick={() => handleChangeNewStatus({ data: record })}
              >
                Emi Details
              </button>

              {record?.emis?.emis?.every(
                (emi: any) => emi?.status === "Paid"
              ) &&
                balance !== 0 &&
                String(userType.type).toLowerCase() !== "customer" &&
                (
                  <button
                    className="btn emi_details_btn btn-primary"
                    style={{ marginLeft: "10px" }}
                    data-bs-toggle="modal"
                    data-bs-target="#payment_modal"
                    data-bs-dismiss="modal"
                    onClick={() => handlePaymentBalance({ data: record })}
                  >
                    Pay
                  </button>
                )}

              {Array.isArray(record?.emis?.emis) &&
                record.emis.emis.length > 0 &&
                record.emis.emis.every((emi: any) => emi?.status === "Paid") &&
                Number(balance) === 0 &&
                String(userType.type).toLowerCase() !== "customer" && (
                  <button
                    className="btn emi_details_btn btn-primary"
                    style={{ marginLeft: "10px" }}
                    onClick={() => handleGenerateNOC(record)}
                  >
                    NOC
                  </button>
                )}
            </div>
          </div>
        );
      },
    },
  ];

  const visibleLoanColumns = isCustomer
    ? column.filter((item: any) => !/principal|principle/i.test(String(item.title)))
    : column;

  const visibleEmiColumns = isCustomer
    ? emiColumn.filter(
      (item: any) =>
        item.dataIndex !== "actions" &&
        !/principal|principle/i.test(String(item.title))
    )
    : emiColumn;

  const handleGenerateNOC = (loan: any) => {
    const customer = customerData;
    const element = document.createElement("div");

    const date = new Date().toLocaleString();

    element.innerHTML = `
      <div style="font-family: Arial; padding: 30px; border:1px solid #ccc;">
      <div style="text-align:center; margin-bottom:20px;">
        <img src="/assets/logo1.png" style="width:60px;" />
        <h2 style="color:#0b7a75; margin:0;">
          VITALFLOW MICRO CARE FOUNDATION
        </h2>
        <p style="margin:5px 0;">
          Ward No-31 Shiv Lok Colony, Domi Road, Hapur, Ghaziabad, Hapur, Uttar Pradesh, India-245101
        </p>
        </div>
        <div style="border-top:6px solid #0b7a75; margin-bottom:20px;"></div>
        <div style="text-align:right;">
          <b>DATE:</b> ${date}
        </div>

        <br/>

        <p><b>To,</b></p>
        <p><b>${customer?.full_name || "Customer Name"}</b></p>
        <p>${customer?.phoneNumber1 || ""}</p>
        <br/>
        <p>
          <b>Subject:</b> No Dues Certificate Loan Account Number: ${loan.loan_id}
        </p>
        <br/>
        <p>Dear Customer,</p>

        <p>
          We do hereby confirm that there are no dues outstanding against loan account number 
          <b>${loan.loan_id}</b> for Rs <b>${Number(loan.approvalAmount) + Number(loan.approvalfilecharge) + Number(loan.othercharges)}</b> granted to you by 
          <b>VITALFLOW MICRO CARE FOUNDATION</b>, as this loan is paid in full.
        </p>

        <br/><br/>

        <p><b>For VITALFLOW MICRO CARE FOUNDATION</b></p>

        <br/><br/>

        <p style="font-size:12px; color:gray;">
          Note: This is a computer generated document. No signature is required.
        </p>

        <hr/>

        <div style="text-align:center;">
          <h3>VITALFLOW MICRO CARE FOUNDATION</h3>
          <p>Contact Number: 7015415526</p>
        </div>

      </div>
    `;

    html2pdf().from(element).save(`NOC_${loan.loan_id}.pdf`);
  };

  const handleOnChangePayment = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPaymentFormData({ ...paymentFormData, [name]: value });
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
    setErrors((prevErrors) => ({ ...prevErrors, paymentMode: "" }));
  };
  const paymentMode = [
    { value: "Select", label: "Select" },
    { value: "UPI", label: "UPI" },
    { value: "BANK", label: "BANK" },
    { value: "CASH", label: "CASH" },
  ];
  const { paymentAmount, penaltyAmount, discount, receipt_number } =
    paymentFormData;
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const handlePayment = async (event: any) => {
    if (isCustomer) return;
    event.preventDefault();
    const { receipt_number, paymentAmount } = paymentFormData;
    const newErrors: { [key: string]: string } = {};

    // if (!receipt_number?.trim())
    //   newErrors.receipt_number = "Receipt number is required";
    if (!paymentAmount || isNaN(Number(paymentAmount)))
      newErrors.paymentAmount = "Valid payment amount is required";
    if (!selectedOption) newErrors.paymentMode = "Payment mode is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const mtIdString = sessionStorage.getItem("info");
    let mtId: { id: string; user_id: string } | null = null;
    if (mtIdString) {
      try {
        mtId = JSON.parse(mtIdString);
      } catch (error) {
        console.error("Failed to parse sessionStorage info:", error);
      }
    }
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    const payload = {
      paymentMode: selectedOption?.value,
      paymentAmount: Number(paymentAmount),
      paymentDate: formattedDate,
      customerId: customerData?.id,
      loanId: products?.id,
      emiId: loanNewData?.id,
      status: "paid",
      penaltyAmount: Number(penaltyAmount),
      receipt_number: "N/A",
      discount: Number(discount),
      user_id: mtId?.user_id,
      utrImageUrl: utrImageUrl,
    };

    try {
      const response = await updatePaymentById(customerData?.id, payload);
      if (response.status === true) {
        // window.location.reload();
        fetchAllFiltersData();

        setTimeout(() => {
          const emiButton = document.querySelector(
            ".emi_details_btn"
          ) as HTMLElement;
          if (emiButton) {
            emiButton.click();
          }
        }, 2000);
      }
      setPaymentFormData(paymentValues);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleBalancePayment = async (event: any) => {
    if (isCustomer) return;
    setBalancePayment(false);
    const lastEmiNo = paymentBalance?.emis?.emis?.length
      ? paymentBalance?.emis.emis[paymentBalance?.emis.emis.length - 1]?.emi_no
      : null;
    event.preventDefault();
    const { receipt_number, paymentAmount } = paymentFormData;
    const newErrors: { [key: string]: string } = {};

    // if (!receipt_number?.trim())
    //   newErrors.receipt_number = "Receipt number is required";
    if (!paymentAmount || isNaN(Number(paymentAmount)))
      newErrors.paymentAmount = "Valid payment amount is required";
    if (!selectedOption) newErrors.paymentMode = "Payment mode is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const mtIdString = sessionStorage.getItem("info");
    let mtId: { id: string; user_id: string } | null = null;
    if (mtIdString) {
      try {
        mtId = JSON.parse(mtIdString);
      } catch (error) {
        console.error("Failed to parse sessionStorage info:", error);
      }
    }

    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    const payload = {
      paymentMode: selectedOption?.value,
      paymentAmount: Number(paymentAmount),
      paymentDate: formattedDate,
      customerId: customerData?.id,
      loanId: products?.id,
      emiId: lastEmiNo,
      status: "paid",
      penaltyAmount: Number(penaltyAmount),
      receipt_number,
      discount: Number(discount),
      user_id: mtId?.user_id,
      utrImageUrl: utrImageUrl,
    };
    try {
      const response = await updatePaymentById(customerData?.id, payload);
      if (response.status === true) {
        fetchAllFiltersData();
        setTimeout(() => {
          const emiButton = document.querySelector(
            ".emi_details_btn"
          ) as HTMLElement;
          if (emiButton) {
            emiButton.click();
          }
        }, 2000);
      }
      setPaymentFormData(paymentValues);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Optional chaining to handle undefined cases
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }
      setError("");
      setImage(file);
      setUtrImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
        setUtrImageUrl(response.data.image);
      }
    }
  };
  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  return (
    <>
      <div className={`page-wrapper modern-ui${isCustomer ? " customer-emi-record-page" : ""}`}>
        <div className="content container-fluid">

          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold">Loan Management</h2>

            <button onClick={handlePrint} className="btn btn-primary px-4">
              <i className="bi bi-printer me-2"></i> Print
            </button>
          </div>

          {/* SEARCH */}
          <div className={`card shadow-sm mb-4${isCustomer ? " customer-emi-welcome" : ""}`}>
            {isCustomer ? (
              <div className="card-body customer-emi-welcome__body">
                <span className="customer-emi-welcome__icon"><i className="ti ti-shield-lock" /></span>
                <div><span className="dashboard-eyebrow">My finance account</span><h3>Your EMI records</h3><p>Your Aadhaar-linked loan information is loaded automatically. This view is read-only.</p></div>
              </div>
            ) : <div className="card-body d-flex gap-3 align-items-end flex-wrap">
              <div>
                <label className="form-label">Search Customer</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Aadhar / Mobile"
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>

              <button onClick={fetchAllFiltersData} className="btn btn-primary">
                Search
              </button>
            </div>}
          </div>

          {/* DASHBOARD */}
          {customerData && (
            <>
              <div className="row">
                <div>
                  <div
                    className="deta"
                  >
                    <div className="print-header d-none align-items-center mb-4 border-bottom pb-3">
                      <img
                        src="https://admin.paybiafinance.com/assets/logo1.png"
                        alt="Logo"
                        style={{ width: "100%", height: '60px', marginRight: '15px', }}
                      />
                      <div className="company-name" style={{ width: "inherit" }}>
                        <h2 className="mb-0 text-primary fw-bold" style={{ width: "inherit" }}>PayBiA Finance</h2>
                        <p className="mb-0 text-muted small">Official Financial Record</p>
                      </div>
                    </div>
                    <div className="customer-detail" style={{ width: '100%', paddingBottom: '20px' }}>
                      <h3>Customer Loans Detail</h3>
                    </div>
                    {customerData?.passportSizePhoto ? (
                      <div className="text-center mb-4">
                        <div className="mb-3">
                          <img
                            src={customerData?.passportSizePhoto ?? "https://admin.paybiafinance.com/assets/logo1.png"}
                            alt="Customer Photo"

                            style={{
                              width: "110px",
                              height: "110px",
                              objectFit: "cover",
                              borderRadius: "50%",
                              border: "3px solid #343a40",
                            }}
                          />
                        </div>
                      </div>
                    ) : (<></>)}
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Financer Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-bank"></i>
                        </span>
                        <div className="form-control bg-light">
                          {`VITALFLOW MICRO CARE FOUNDATION`}
                        </div>
                      </div>
                    </div>

                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Customer Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-person-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.full_name || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Group Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="ti ti-users-group" />
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.group?.groupName || <span className="text-muted">not assigned</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Branch Name
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="ti ti-building-store" />
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.retailer?.company_name || customerData?.retailer?.full_name || <span className="text-muted">not assigned</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Email
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-envelope-at-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.email || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Customer Account Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-hash"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.loanAccountNumber || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Pan Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-card-heading"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.PanNumber || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Phone Number
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-telephone-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.phoneNumber1
                            ? customerData?.phoneNumber1
                            : customerData?.phoneNumber2 || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Aadhar Number                                </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-fingerprint"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.aadharNumber || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Father's Name                               </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-person-badge-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {customerData?.fatherName || <span className="text-muted">not available</span>}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Address                              </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-geo-alt-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {address
                            ? `${address.addressLine || ""}, ${address.city || ""
                              }, ${address.state || ""},${address.country || ""
                              }, ${address.pincode || ""},`
                              .replace(/^, |, $/g, "")
                              .trim()
                            : "not available"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-label fw-bold text-secondary small text-uppercase">
                        Current Address                              </label>
                      <div className="input-group">
                        <span className="input-group-text bg-primary text-white">
                          <i className="bi bi-house-fill"></i>
                        </span>
                        <div className="form-control bg-light">
                          {curraddress
                            ? `${curraddress.addressLine1 || ""}, ${curraddress.city1 || ""
                              }, ${curraddress.state1 || ""},${curraddress.country1 || ""
                              }, ${curraddress.pincode1 || ""}`
                              .replace(/^, |, $/g, "")
                              .trim()
                            : "not available"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* LOANS */}
              <div className="card shadow-sm mb-4">
                <div className="card-header">Loan Details</div>
                <div className="card-body">
                  <Table dataSource={loanData} columns={visibleLoanColumns} Selection={true} />
                </div>
              </div>

              {/* EMI */}
              {emiDetail && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header">EMI Details</div>
                  <div className="card-body">
                    <Table dataSource={emiData} columns={visibleEmiColumns} Selection={true} />
                  </div>
                </div>
              )}

              {/* PAYMENTS */}
              {paymentData?.length > 0 && (
                <div className="card shadow-sm mb-4">
                  <div className="card-header">Payments</div>
                  <div className="card-body">
                    <Table dataSource={paymentData} columns={paymentColumn} Selection={true} />
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* PAYMENT MODAL */}
      {!isCustomer && <div className="modal fade" id="payment_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center"></div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Payment Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      {/* <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Receipt Number
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            required
                            name="receipt_number"
                            value={receipt_number}
                            onChange={handleOnChangePayment}
                            className="form-control"
                            hidden
                          />
                          {errors.receipt_number && (
                            <small className="text-danger">
                              {errors.receipt_number}
                            </small>
                          )}
                        </div>
                      </div> */}

                      {!balancePayment && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Emi Amount
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="DisbursementAmount"
                              value={loanNewData?.amount || 0}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Payment Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            required
                            type="text"
                            name="paymentAmount"
                            value={paymentAmount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                          {errors.paymentAmount && (
                            <small className="text-danger">
                              {errors.paymentAmount}
                            </small>
                          )}
                        </div>
                      </div>

                      {!balancePayment && (
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Due Date
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="utrNumber"
                              value={loanNewData?.due_date}
                              className="form-control"
                              disabled
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Penalty Amount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="penaltyAmount"
                            value={penaltyAmount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Discount
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="discount"
                            value={discount}
                            onChange={handleOnChangePayment}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Select Payment Mode
                          </label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={paymentMode}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="Payment Mode"
                          />
                          {errors.paymentMode && (
                            <small className="text-danger d-block mt-1">
                              {errors.paymentMode}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="profile-upload col-md-12">
                        {!utrImage && (
                          <div className="mb-2">
                            <h6 className="mb-1">Upload Utr Image</h6>
                            <p className="fs-12">Image should be below 4 MB</p>

                            {error && <p className="text-danger">{error}</p>}
                          </div>
                        )}
                        <div className="profile-uploader d-flex align-items-center">
                          <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                            {utrImage ? "Replace" : "Upload"}
                            <input
                              type="file"
                              className="form-control image-sign"
                              accept="image/*"
                              onChange={handleFileChange}
                            />
                          </div>
                          <Link
                            to="#"
                            className="btn btn-light btn-sm"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Link>
                        </div>
                        {utrImage && (
                          <div className="mt-3">
                            <p>Preview:</p>
                            <img
                              src={URL.createObjectURL(utrImage)}
                              alt="Profile Preview"
                              className="img-thumbnail"
                              style={{
                                maxWidth: "150px",
                                maxHeight: "150px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                      onClick={
                        balancePayment ? handleBalancePayment : handlePayment
                      }
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>}
    </>
  );
};

export default PendingEmisList;
